export const cubesImage = `                                                           
  RRRRRRRRRRRRRRRRR   UUUUUUUU     UUUUUUUU        GGGGGGGGGGGGG
  R::::::::::::::::R  U::::::U     U::::::U     GGG::::::::::::G
  R::::::RRRRRR:::::R U::::::U     U::::::U   GG:::::::::::::::G
  RR:::::R     R:::::RUU:::::U     U:::::UU  G:::::GGGGGGGG::::G
    R::::R     R:::::R U:::::U     U:::::U  G:::::G       GGGGGG
    R::::R     R:::::R U:::::D     D:::::U G:::::G              
    R::::RRRRRR:::::R  U:::::D     D:::::U G:::::G              
    R:::::::::::::RR   U:::::D     D:::::U G:::::G    GGGGGGGGGG
    R::::RRRRRR:::::R  U:::::D     D:::::U G:::::G    G::::::::G
    R::::R     R:::::R U:::::D     D:::::U G:::::G    GGGGG::::G
    R::::R     R:::::R U:::::D     D:::::U G:::::G        G::::G
    R::::R     R:::::R U::::::U   U::::::U  G:::::G       G::::G
  RR:::::R     R:::::R U:::::::UUU:::::::U   G:::::GGGGGGGG::::G
  R::::::R     R:::::R  UU:::::::::::::UU     GG:::::::::::::::G
  R::::::R     R:::::R    UU:::::::::UU         GGG::::::GGG:::G
  RRRRRRRR     RRRRRRR      UUUUUUUUU              GGGGGG   GGGG                                                               
                                                                                                       
                                                                
     
                                                                
                                                                
'  RRRRRRRRRRRRRRRRR   UUUUUUUU     UUUUUUUU        GGGGGGGGGGGGG
'  R::::::::::::::::R  U::::::U     U::::::U     GGG::::::::::::G
'  R::::::RRRRRR:::::R U::::::U     U::::::U   GG:::::::::::::::G
'  RR:::::R     R:::::RUU:::::U     U:::::UU  G:::::GGGGGGGG::::G
'    R::::R     R:::::R U:::::U     U:::::U  G:::::G       GGGGGG
'    R::::R     R:::::R U:::::D     D:::::U G:::::G              
'    R::::RRRRRR:::::R  U:::::D     D:::::U G:::::G              
'    R:::::::::::::RR   U:::::D     D:::::U G:::::G    GGGGGGGGGG
'    R::::RRRRRR:::::R  U:::::D     D:::::U G:::::G    G::::::::G
'    R::::R     R:::::R U:::::D     D:::::U G:::::G    GGGGG::::G
'    R::::R     R:::::R U:::::D     D:::::U G:::::G        G::::G
'    R::::R     R:::::R U::::::U   U::::::U  G:::::G       G::::G
'  RR:::::R     R:::::R U:::::::UUU:::::::U   G:::::GGGGGGGG::::G
'  R::::::R     R:::::R  UU:::::::::::::UU     GG:::::::::::::::G
'  R::::::R     R:::::R    UU:::::::::UU         GGG::::::GGG:::G
'  RRRRRRRR     RRRRRRR      UUUUUUUUU              GGGGGG   GGGG
                                                               
`;
